import { render, staticRenderFns } from "./DefaultCommissionForm.vue?vue&type=template&id=92642e4c&scoped=true"
import script from "./DefaultCommissionForm.vue?vue&type=script&lang=js"
export * from "./DefaultCommissionForm.vue?vue&type=script&lang=js"
import style0 from "./DefaultCommissionForm.vue?vue&type=style&index=0&id=92642e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92642e4c",
  null
  
)

export default component.exports